{
  "Active": "Active",
  "Add": "Add",
  "Archived": "Archived",
  "Close": "Close",
  "Contact blocked": "Contact blocked",
  "Contact opted out": "Contact opted out",
  "Contacts In This Group": "Contacts In This Group",
  "Contacts Under This Number": "Contacts Under This Number",
  "Contacts With This Number": "Contacts With This Number",
  "Custom Number": "Custom Number",
  "Deceased": "Deceased",
  "Edit Group Chat Name": "Edit Group Chat Name",
  "F": "F",
  "From:": "From:",
  "Head of Household": "Head of Household",
  "Hide": "Hide",
  "Inactive": "Inactive",
  "Lead": "Lead",
  "M": "M",
  "Make Phone Owner": "Make Phone Owner",
  "NB": "NB",
  "Non-Patient": "Non-Patient",
  "O": "O",
  "One or more people in this group have opted out.": "One or more people in this group have opted out.",
  "One or more people in this group is blocked.": "One or more people in this group is blocked.",
  "Open Associated Contact Actions": "Open Associated Contact Actions",
  "Phone Owner": "Phone Owner",
  "Prospective": "Prospective",
  "Select a number": "Select a number",
  "Select to focus another contact...": "Select to focus another contact...",
  "Set": "Set",
  "Show hidden participant names": "Show hidden participant names",
  "There are multiple contacts listed under this number": "There are multiple contacts listed under this number",
  "This contact has been blocked.": "This contact has been blocked.",
  "This contact has opted out of receiving messages from you.": "This contact has opted out of receiving messages from you.",
  "To:": "To:",
  "{{count}} Other_one": "{{count}} Other",
  "{{count}} Other_other": "{{count}} Others",
  "{{phoneOwnerName}} (Phone Owner)\n{{contextContactName}}": "{{phoneOwnerName}} (Phone Owner)\n{{contextContactName}}"
}
